import dayjs from 'dayjs';
import getOffsetTime from '../../../../../utils/getOffsetTime.js';


const addAssignment = (itemDetails, optimisticLiveSchedule, dayTypesAll, dayTypesAllowTour, resourceId) => {
  if (itemDetails.status === 10) {
    // standby assignment, must create dayType to house assignment
    const { dayTypeId, assignmentStartTime, assignmentEndTime, activityType,
    jobId, jobNumber, serviceName, costObject, status, descriptionComment } = itemDetails;
    const tempJobElementId = `${Math.floor(Math.random() * (19999999 - 10000000 + 1)) + 10000000}-optimistic`;

    let startTime = dayjs(assignmentStartTime);
    let timeZoneOffset = getOffsetTime(startTime);
   
    startTime = startTime.subtract(timeZoneOffset, 'minute').unix();
    let endTime = dayjs(assignmentEndTime).subtract(timeZoneOffset, 'minute').unix();

      // create new assignment
    const assignment = {
      jeId: tempJobElementId,
      startTime,
      endTime,
      service: serviceName,
      activityType,
      requestNumber: jobNumber,
      jobId,
      costObject: costObject.costObjectName,
      costObjectNumber: costObject.costObjectNumber,
      description: descriptionComment,
      myAssignmentComment: null,
      comment: null, // scheduler comment
      jeStatus: status,
      isApproved: false // just created, can't be approved yet
    };
    // create assignment-dayType (not a dayType in STORM desktop, just created to house standby assignment on the frontend)
    const dayType = {
      rdtId: tempJobElementId,
      dayStart: "0",
      assignment
    };
    return dayType;
  } else if (itemDetails.addTourForAssignment) {
      // create assignment
      const { assignmentStartTime, assignmentEndTime, activityType,
      jobId, jobNumber, serviceName, costObject, status, descriptionComment } = itemDetails;
      const tempJobElementId = `${Math.floor(Math.random() * (19999999 - 10000000 + 1)) + 10000000}-optimistic`;

      let startTime = dayjs(assignmentStartTime);
      let timeZoneOffset = getOffsetTime(startTime);

      startTime = startTime.subtract(timeZoneOffset, 'minute').unix();
      let endTime = dayjs(assignmentEndTime).subtract(timeZoneOffset, 'minute').unix();

      const assignment = {
        jeId: tempJobElementId,
        startTime,
        endTime,
        service: serviceName,
        activityType,
        requestNumber: jobNumber,
        jobId,
        costObject: costObject.costObjectName,
        costObjectNumber: costObject.costObjectNumber,
        description: descriptionComment,
        myAssignmentComment: null,
        comment: null, // scheduler comment
        jeStatus: status,
        isApproved: false // just created, can't be approved yet
      };

      const { dayTypeId, tourStartTime, tourEndTime, mealStartTime } = itemDetails;
      const { notification, comment, comment15  } = itemDetails.tourParams;
      const tempDayTypeId = `${Math.floor(Math.random() * (19999999 - 10000000 + 1)) + 10000000}-optimistic`;
      const tempTourId = `${Math.floor(Math.random() * (19999999 - 10000000 + 1)) + 10000000}-optimistic`;
      const tempMealId = `${Math.floor(Math.random() * (9999999 - 9000000 + 1)) + 9000000}-optimistic`;

      startTime = dayjs(tourStartTime);
      timeZoneOffset = getOffsetTime(startTime);
      
      startTime = startTime.subtract(timeZoneOffset, 'minute').unix();
      let mealStartTimeUnix = dayjs(mealStartTime).subtract(timeZoneOffset, 'minute').unix();
      let mealEndTimeUnix = dayjs(mealStartTime).subtract(timeZoneOffset - 60, 'minute').unix();  // all meal an hour for now
      // create new dayType, tour and meal
      const tour = {
        tourId: tempTourId,
        startTime,
        duration: dayjs(tourEndTime).diff(dayjs(tourStartTime),'hour'),
        notificationComment: notification,
        tourComment: comment,
        myTourComment: comment15,
        tourIndicators: [],
        tourPayTransactions: [],
        meal: {
          mealId: tempMealId,
          mealTime: mealStartTimeUnix,
          mealEndTime: mealEndTimeUnix,
          red: false
        },
        assignments: {
          [assignment.jeId]: assignment
        }
      };
      const dayType = {
        rdtId: tempDayTypeId,
        title: dayTypesAllowTour.find((elem) => elem.id == dayTypeId).name,
        dayOff: null,
        tour
      };
      return dayType;

  } else if (itemDetails.editTourForAssignment) {
      // create assignment
      const { assignmentStartTime, assignmentEndTime, activityType,
      jobId, jobNumber, serviceName, costObject, status, descriptionComment } = itemDetails;
      const tempJobElementId = `${Math.floor(Math.random() * (19999999 - 10000000 + 1)) + 10000000}-optimistic`;

      let startTime = dayjs(assignmentStartTime);
      let timeZoneOffset = getOffsetTime(startTime);
      startTime = startTime.subtract(timeZoneOffset, 'minute').unix();
      let endTime = dayjs(assignmentEndTime).subtract(timeZoneOffset, 'minute').unix();

      const assignment = {
        jeId: tempJobElementId,
        startTime,
        endTime,
        service: serviceName,
        activityType,
        requestNumber: jobNumber,
        jobId,
        costObject: costObject.costObjectName,
        costObjectNumber: costObject.costObjectNumber,
        description: descriptionComment,
        myAssignmentComment: null,
        comment: null, // scheduler comment
        jeStatus: status,
        isApproved: false // just created, can't be approved yet
      };

      const { tourId, rdtId, dayTypeId, tourStartTime, tourEndTime, mealStartTime } = itemDetails;
      const { notification, comment, comment15  } = itemDetails.tourParams;
      // const { mealId, mealStart, mealEnd, } = itemDetails.tourDetails.meals[0];
      const tempRdtId = `${rdtId}-optimistic`;
      const tempTourId = `${tourId}-optimistic`;
      // const tempMealId = `${mealId}-optimistic`;

      timeZoneOffset = getOffsetTime(dayjs(tourStartTime));
      // console.log(`rdtId: ${rdtId}`); // debug
      // console.log(`tourId: ${tourId}`); // debug
      // console.log(timeZoneOffset); // debug
      startTime = dayjs(tourStartTime);
      // console.log(startTime); // debug
      startTime = startTime.subtract(timeZoneOffset, 'minute').unix();
      // let mealTime = dayjs(mealStartTime).add(4, 'hour').unix();
      // create new dayType, tour and meal
      const tour = {
        tourId: tempTourId,
        startTime,
        duration: dayjs(tourEndTime).diff(dayjs(tourStartTime),'hour'),
        notificationComment: notification,
        tourComment: comment,
        myTourComment: comment15,
        tourIndicators: [],
        tourPayTransactions: [],
        // meal: {
        //   mealId: tempMealId,
        //   mealTime,
        //   red: false
        // },
        assignments: {
          [assignment.jeId]: assignment
        }
      };
      // build new resource obj which will house dayTypes array, which houses tour obj
      const origResource = optimisticLiveSchedule.find((elem) => resourceId == elem.rId);
      const resource = JSON.parse(JSON.stringify(origResource));
      if (resource.dayTypes[rdtId]) {
        // create and populate new dayType
        resource.dayTypes[tempRdtId] = {};
        resource.dayTypes[tempRdtId].rdtId = tempRdtId;
        resource.dayTypes[tempRdtId].dayTypeId = dayTypeId
        resource.dayTypes[tempRdtId].title = dayTypesAllowTour.find((elem) => elem.id == dayTypeId).name;
        resource.dayTypes[tempRdtId].tour = tour;
        // *** NEW *** copy existing assignments (if any)
        if (resource.dayTypes[rdtId].tour) {
          resource.dayTypes[tempRdtId].tour.assignments = resource.dayTypes[rdtId].tour.assignments;
          // insert just-created assignment into assignments object
          resource.dayTypes[tempRdtId].tour.assignments[assignment.jeId] = assignment;
        }
        // delete old dayType
        delete resource.dayTypes[rdtId];
      }
      return resource;
  }
}

export default addAssignment;
